import React, { useState } from "react";
import "./FAQS.css";
import Navbar from "../../Common/Navbar/Navbar";
import Footer from "../../Common/Footer/Footer";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";

const FAQS = () => {
  const [openedCollapse, setOpenedCollapse] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const handleCollapseClick = (index) => {
    setOpenedCollapse((prev) => (prev === index ? null : index));
  };

  const handleLoadMoreClick = () => {
    setShowAll(true);
  };

  const handleShowLessClick = () => {
    setShowAll(false);
    setOpenedCollapse(null);
  };
  const accordionData = [
    {
      title: "What is APNA KONNECT ?",
      text: "We are a hyper local community app working on bring local commection back in the digital age",
      videoUrl: "https://apnakonnect.com/media/introduction.mp4",
    },
    {
      title: "What is Mission and Vision of APNA KONNECT ?",
      text: "We are a hyper local community community app working on real world local connections",
      videoUrl: "https://apnakonnect.com/media/missionAndVision.mp4",
    },
    {
      title: "How to create public community ?",
      text: "This is how you can can public local communities on APNA KONNECT",
      videoUrl: "https://apnakonnect.com/media/createpubliccommunity.mp4",
    },
    {
      title: "How to create private community ?",
      text: "This is how you can can private local communities on APNA KONNECT",
      videoUrl: "https://apnakonnect.com/media/privatecommunity.mp4",
    },
    {
      title: "How to become community pillar ?",
      text: "Community pillat are the people who want to create a change in thier locality",
      videoUrl: "https://apnakonnect.com/media/becomecommunitypillaroflocality.mp4",
    },
    {
      title: "How to invite friends and family ?",
      text: "This is how you can invite people on APNA KONNECT",
      videoUrl: "https://apnakonnect.com/media/invitesKonnects.mp4",
    },
    {
      title: "Add members to your community ?",
      text: "This is how you can add members to community",
      videoUrl: "https://apnakonnect.com/media/growcommunity.mp4",
    },
    // New content
    {
      title: "How to engage your community member",
      text: "This video demonstrates how to effectively engage your community members.",
      videoUrl: "https://apnakonnect.com/media/engagecommunitymember.mp4",
    },
    {
      title: "How to make events / activity",
      text: "Learn how to create engaging events and activities for your community.",
      videoUrl: "https://apnakonnect.com/media/apnakonnectEvent.mp4",
    },
    {
      title: "How to create business profile",
      text: "This video guides you through the process of creating a business profile on APNA KONNECT.",
      videoUrl: "https://apnakonnect.com/assets/img/supportVideo1.mp4",
    },
    {
      title: "How to create ads on apna konnect",
      text: "Discover how to create effective ads to promote your business or community on APNA KONNECT.",
      videoUrl: "https://apnakonnect.com/assets/img/supportVideo2.mp4",
    },
  ];
  

  const visibleData = showAll ? accordionData : accordionData.slice(0, 4);

  return (
    <>
      <Navbar />
      <div className="faqs">
        <div
          style={{ display: "flex", flexDirection: "column", marginTop: "10%" }}
        >
          {visibleData.map((data, index) => (
            <Accordion
              key={index}
              expanded={openedCollapse === index}
              onChange={() => handleCollapseClick(index)}
            >
              <AccordionSummary>
                <Typography>{data.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div style={{ width: "100%" }}>
                  <Typography>{data.text}</Typography>

                  {openedCollapse === index && (
                    <iframe
                      title={`FAQ Video ${index}`}
                      width="100%"
                      height="300"
                      src={`${data.videoUrl}?autoplay=1`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
      <div className="faq-accordionData">
        <div style={{ display: "flex", justifyContent: "center" }}>
          {showAll ? (
            <button
              className="btn-show-less Acc-button"
              onClick={handleShowLessClick}
              style={{ background: "#00AC73", color: "#fff" }}
            >
              Show Less
            </button>
          ) : (
            <button
              className="btn-show-less Acc-button"
              onClick={handleLoadMoreClick}
              style={{ background: "#00AC73", color: "#fff" }}
            >
              Show More
            </button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQS;
